// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__36RBg","topBottomGutter":"Layout_topBottomGutter__nzYIl"};